import type { LucideIcon } from "lucide-react";

export type IconProps = {
  icon: LucideIcon;
  size?: number;
  label?: string;
  className?: string;
};

export const Icon = ({ icon: IconComponent, size = 16, label, className }: IconProps) => {
  const a11y = label
    ? { "aria-label": label, role: "img" as const }
    : { "aria-hidden": true as const };
  return (
    <IconComponent width={size} height={size} strokeWidth={1.75} className={className} {...a11y} />
  );
};
